export const conditionArr = [{
    name: '型号',
    data: [{
        name: '8位MCU',
        value: false
    },{
        name: '32位MCU',
        value: false
    },{
        name: '触摸型MCU',
        value: false
    },{
        name: 'LCD型MCU',
        value: false
    }],
},{
    name: 'CPU核',
    data: [{
        name: '8 bit',
        value: false
    },{
        name: '32 bit',
        value: false
    }],
},{
    name: '工艺特征',
    data: [{
        name: '3V OTP',
        value: false
    },{
        name: '3V OTP+EE',
        value: false
    },{
        name: '5V OTP',
        value: false
    },{
        name: '5V OTP+EE',
        value: false
    },{
        name: '5V MTP',
        value: false
    },{
        name: '5V MTP+EE',
        value: false
    },{
        name: '5V FLASH',
        value: false
    },{
        name: '5V FLASH+EE',
        value: false
    },{
        name: '3V FLASH',
        value: false
    }],
},{
    name: '产品特征',
    data: [{
        name: 'LCD',
        value: false
    },{
        name: '12-bit ADC',
        value: false
    },{
        name: '24-bit ADC',
        value: false
    },{
        name: 'EE',
        value: false
    },{
        name: 'PWM',
        value: false
    },{
        name: 'RTC',
        value: false
    },{
        name: '强驱动IO',
        value: false
    },{
        name: 'Touch',
        value: false
    },{
        name: 'OPA/PGA',
        value: false
    },{
        name: 'UART',
        value: false
    },{
        name: 'SPI',
        value: false
    },{
        name: 'IIC',
        value: false
    },{
        name: 'LDO',
        value: false
    },{
        name: 'TPS',
        value: false
    },{
        name: 'DAC',
        value: false
    }],
},{
    name: 'ROM容量',
    data: [{
        name: '<4KB',
        value: false
    },{
        name: '4KB',
        value: false
    },{
        name: '8KB',
        value: false
    },{
        name: '16KB',
        value: false
    },{
        name: '32KB',
        value: false
    },{
        name: '64KB',
        value: false
    },{
        name: '128KB',
        value: false
    },{
        name: '>128KB',
        value: false
    }],
},{
    name: 'RAM容量',
    data: [{
        name: '128B',
        value: false
    },{
        name: '256B',
        value: false
    },{
        name: '512B',
        value: false
    },{
        name: '1KB',
        value: false
    },{
        name: '2KB',
        value: false
    },{
        name: '4KB',
        value: false
    },{
        name: '8KB',
        value: false
    },{
        name: '>10KB',
        value: false
    }],
},{
    name: '封装脚位数',
    data: [{
        name: '8',
        value: false
    },{
        name: '14/16',
        value: false
    },{
        name: '20',
        value: false
    },{
        name: '24',
        value: false
    },{
        name: '28',
        value: false
    },{
        name: '32',
        value: false
    },{
        name: '44/48',
        value: false
    },{
        name: '52/64',
        value: false
    }],
}]